import { Tooltip } from 'antd'
import SearchInput from 'components/Main/SearchInput'
import { GlobalContext } from 'Global'
import React from 'react'
import Notification from 'views/Notification'
import Profile from 'views/Profile'
import SupportTicket from 'views/SupportTicket'
import Authentication from '../modules/Authentication'

const auth = new Authentication()

function Header() {
  const { collapsed, setCollapsed, logo, avatar, member, primaryColor } = React.useContext(GlobalContext)

  const user = {
    username: member.fn,
    avatar,
    logo,
  }

  return (
    <div className="flex-shrink-0 flex">
      <div
        onMouseEnter={() => setCollapsed(false)}
        onMouseLeave={() => setCollapsed(true)}
        className={`${
          collapsed ? 'w-16 hover:w-64 overflow-hidden' : 'w-64'
        } flex-shrink-0 px-4 py-3 bg-${primaryColor}-800`}>
        <Profile/>
      </div>

      <div className={`flex-1 flex items-center justify-between bg-${primaryColor}-700 flex-grow`}>
        <nav className="flex">
          <div className="logo">
            <img src={user.logo} className="h-12" />
          </div>
        </nav>
        <div className="flex items-center flex-row">
          <div className="relative w-96">
            <SearchInput />
          </div>
          <SupportTicket/>
          <Notification/>
          <Tooltip placement="bottomRight" title={'Logout'}>
            <button onClick={auth.logout} className={`m-2 text-${primaryColor}-400 hover:text-${primaryColor}-200`}>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default Header
